import { useEffect } from 'react'

const StrapiRedirect = () => {
  useEffect(() => {
  window.location.href = `${process.env.REACT_APP_strapiUrl}/admin/content-manager`;
}, []);
}

export default StrapiRedirect